import React, { Component } from 'react';
import './styles.css';
import classNames from 'classnames';
import { BlueIconWrapper, Button } from '../../atoms';

/**
 * WorkplaceChallenges Component
 *
 * @typedef {Object} Challenge
 * @prop {string} [label] - Optional label for the Challenge
 * @prop {Object} image - Image object
 * @prop {string} image.src - Image source path
 * @prop {string} image.alt - Image alt text
 * @prop {string} title - Challenge title
 * @prop {string} content - Challenge content description
 * @prop {string} [href] - Challenge btn href
 * @prop {string} buttonLabel - Button label text
 *
 * @typedef {Object} Props
 * @prop {Challenge[]} challenges - Array of Challenge objects to display
 * @prop {string} className - CSS class name
 * @prop {string} heading - Main heading text
 * @prop {string} href - Link URL for the button
 *
 * @augments {Component<Props>}
 */
export default class WorkplaceChallenges extends Component {

	genClassName = (className) => classNames('WorkplaceChallenges', className);

	genTextBlock = (challenges) =>
		challenges.map((challenge, idx) => {

			if (challenge.type === 'button') {
				// eslint-disable-next-line react/no-array-index-key
				return (<div className='Column' key={idx}>
					<Button
						className='pilotProgram'
						variant='blue'
						href={challenge.href}>
						{challenge.buttonLabel}
					</Button>
				</div>);
			}

			// eslint-disable-next-line react/no-array-index-key
			return (<div className='Column' key={idx}>
				<BlueIconWrapper className='challengePicture' alt={challenge.image.alt} src={challenge.image.src} />
				<div className={'infoBlock'}>
					<h2 className='challengeTitle'>{challenge.title}</h2>
					<p className={'challengeContent'}>{challenge.content}</p>
					<p className='solution'>{challenge.solution}</p>
				</div>
			</div>);
		});

	render () {
		const { challenges, heading, className } = this.props;

		return (
			<section className={this.genClassName(className)}>
				{heading ? <h1>{heading}</h1> : ''}
				<div className='WorkplaceChallenges-container'>
					<div className='Row'>{this.genTextBlock(challenges)}</div>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/WorkplaceChallenges/WorkplaceChallenges.js